<template>
  <div class="date">
    <div><CalendarOutlined :style="{ fontSize: '1.4em' }" /></div>
    <div>
      <p :style="{ fontSize: fontSize.p + 'em' }">
        &ensp;{{ data.pagePublishUp }}
      </p>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
import { CalendarOutlined } from "@ant-design/icons-vue";
export default {
  name: "Date",
  props: {
    data: {
      type: Object,
      default() {
        return {
          pageId: "",
          nodeId: "",
          pagePublishUp: "",
        };
      },
    },
  },
  components: {
    CalendarOutlined,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.date {
  display: flex;
  align-items: flex-end;
  margin-left: 65px;
  margin-right: 50px;
}
</style>
